import type { defineAsyncComponent, AsyncComponentLoader } from 'vue';

type AsyncComponentPrivateAttributes = {
  __asyncLoader?: AsyncComponentLoader;
  __asyncResolved?: boolean;
};

export const preFetchAsyncComponents = (asyncComp: ReturnType<typeof defineAsyncComponent> & AsyncComponentPrivateAttributes) => {
  if (!asyncComp.__asyncResolved) return asyncComp?.__asyncLoader?.();
};
